import React from 'react';

import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import styled, { css } from 'styled-components';
import { NewStyledIconButton } from 'styles/common';

import { getColorFromKey } from 'constants/helper';

const CircularOutlineIcon = ({ className, onClick, absolutePosition, icon, color = '#999', ...props }) => {
  const Icon = icon || DefaultArrowIcon;
  return (
    <Container
      color={color}
      circular
      onClick={onClick || (() => {})}
      absolutePosition={absolutePosition}
      className={className}
      {...props}
    >
      <Icon />
    </Container>
  );
};

const Container = styled(NewStyledIconButton)`
  height: 24px;
  width: 24px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(props) => getColorFromKey(props.color || props.theme.palette.text.secondary)};
  ${({ absolutePosition }) =>
    absolutePosition &&
    `
       position: absolute;
       right: 10px;
       top: 50%;
       transform: translateY(-50%);
   `}
  ${(props) =>
    props.color &&
    css`
      svg {
        fill: ${getColorFromKey(props.color)};
      }
    `};
`;

const DefaultArrowIcon = styled(KeyboardArrowRightIcon)`
  width: 20px;
  margin-right: -2px;
`;

export default CircularOutlineIcon;
